/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungsaenderungsAntragDto } from '../../models/buchungsaenderungs-antrag-dto';
import { UpdateBuchungsaenderungsAntragDto } from '../../models/update-buchungsaenderungs-antrag-dto';

export interface UpdateOneBuchungsaenderungsAntrag$Json$Params {

/**
 * ID des Antrags, der aktualisiert werden soll
 */
  antragsId: string;
  
    /**
     * Aktualisierter Status
     */
    body?: UpdateBuchungsaenderungsAntragDto
}

export function updateOneBuchungsaenderungsAntrag$Json(http: HttpClient, rootUrl: string, params: UpdateOneBuchungsaenderungsAntrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungsaenderungsAntragDto>> {
  const rb = new RequestBuilder(rootUrl, updateOneBuchungsaenderungsAntrag$Json.PATH, 'put');
  if (params) {
    rb.path('antragsId', params.antragsId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungsaenderungsAntragDto>;
    })
  );
}

updateOneBuchungsaenderungsAntrag$Json.PATH = '/v1/buchungsaenderungsAntraege/{antragsId}';
